import React from 'react';
import { motion } from 'framer-motion';

const Accommodation: React.FC = () => {
  const hotels = [
    {
      name: 'The Grand Hotel',
      distance: '5 minutes from venue',
      price: '£150-200 per night',
      description: 'Luxury hotel with spa facilities and fine dining',
    },
    {
      name: 'Cozy Inn & Suites',
      distance: '10 minutes from venue',
      price: '£80-120 per night',
      description: 'Comfortable accommodation with modern amenities',
    },
    {
      name: 'Countryside B&B',
      distance: '15 minutes from venue',
      price: '£60-90 per night',
      description: 'Charming bed & breakfast in beautiful countryside',
    }
  ];

  return (
    <div className="bg-gradient-to-br from-cream via-white to-blush py-12 px-4" style={{ minHeight: '100vh', paddingBottom: '20vh' }}>
      <div className="max-w-4xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-center mb-12"
        >
          <h1 className="page-header text-charcoal mb-4">
            Accommodation
          </h1>
          <p className="body-text text-gray-light">
            We recommended the following places to stay near our venue
          </p>
        </motion.div>

        <div className="grid md:grid-cols-1 gap-8">
          {hotels.map((hotel, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: index * 0.1 }}
              className="bg-white/80 backdrop-blur-sm rounded-lg p-6 shadow-lg text-center"
            >
              <h2 className="section-header text-charcoal mb-2">
                {hotel.name}
              </h2>
              <p className="body-text text-gray-light mb-3">
                {hotel.description}
              </p>
              <div className="mb-2">
                <span className="small-text text-gray-light">Distance: </span>
                <span className="font-medium text-charcoal">{hotel.distance}</span>
              </div>
              <div className="mb-4">
                <span className="small-text text-gray-light">Price Range: </span>
                <span className="font-medium text-gold">{hotel.price}</span>
              </div>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.4 }}
          className="mt-12 text-center p-6 bg-white/60 rounded-lg"
        >
          <h3 className="subheading text-charcoal mb-4">
            Need help with accommodation?
          </h3>
          <div className="body-text text-gray-700 space-y-2">
            <p>Contact us at <a href="mailto:contact@catandri.ch" className="text-gold hover:underline">contact@catandri.ch</a></p>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default Accommodation;